import { Field, RadioGroup, Stack } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'

/** `RadioGroup` values are strings; these are the only two. */
const YES = 'yes'
const NO = 'no'

type Props = {
  label: string
  helper: string
  value: boolean
  onChange: (value: boolean) => void
}

/**
 * One of the resolution's two yes/no questions.
 *
 * `aria-label` on the group, not just a `Field.Label` beside it: Chakra's
 * `Field.Root` does not associate its label with a radio group the way it
 * does with an input, so without this the group is announced unnamed and
 * cannot be addressed by name in a test either.
 */
export function YesNoField({
  label,
  helper,
  value,
  onChange,
}: Readonly<Props>) {
  const { t } = useTranslation('features', { useSuspense: false })

  return (
    <Field.Root>
      <Field.Label>{label}</Field.Label>
      <RadioGroup.Root
        aria-label={label}
        value={value ? YES : NO}
        onValueChange={(details) => onChange(details.value === YES)}
      >
        <Stack direction="row" gap={4}>
          <RadioGroup.Item value={YES}>
            <RadioGroup.ItemHiddenInput />
            <RadioGroup.ItemIndicator />
            <RadioGroup.ItemText>
              {String(t('salesforceIngest.form.yes'))}
            </RadioGroup.ItemText>
          </RadioGroup.Item>
          <RadioGroup.Item value={NO}>
            <RadioGroup.ItemHiddenInput />
            <RadioGroup.ItemIndicator />
            <RadioGroup.ItemText>
              {String(t('salesforceIngest.form.no'))}
            </RadioGroup.ItemText>
          </RadioGroup.Item>
        </Stack>
      </RadioGroup.Root>
      <Field.HelperText>{helper}</Field.HelperText>
    </Field.Root>
  )
}
